import { useState, useEffect, useMemo } from 'react';
import Layout from '../../components/feature/Layout';
import PortfolioHero from './components/PortfolioHero';
import CaseStudyGrid from './components/CaseStudyGrid';
import CaseStudyDetail from './components/CaseStudyDetail';
import PortfolioInquiry from './components/PortfolioInquiry';
import { caseStudies } from '../../mocks/caseStudies';

interface CaseStudy {
  id: string;
  title: string;
  client: string;
  category: string;
  location: string;
  flag: string;
  year: string;
  duration: string;
  heroImage: string;
  thumbnail: string;
  challenge: string;
  solution: string;
  results: { metric: string; label: string }[];
  services: string[];
  testimonial: { quote: string; author: string; role: string };
  gallery: string[];
}

export default function PortfolioPage() {
  const [activeFilter, setActiveFilter] = useState('All');
  const [selectedProject, setSelectedProject] = useState<CaseStudy | null>(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const filteredProjects = useMemo(() => {
    if (activeFilter === 'All') return caseStudies;
    return caseStudies.filter((p) => p.category === activeFilter);
  }, [activeFilter]);

  const handleSelectProject = (project: CaseStudy) => {
    setSelectedProject(project);
  };

  const handleBack = () => {
    setSelectedProject(null);
  };

  return (
    <Layout>
      <div className="min-h-screen bg-white">
        {selectedProject ? (
          <CaseStudyDetail project={selectedProject} onBack={handleBack} />
        ) : (
          <>
            <PortfolioHero
              activeFilter={activeFilter}
              onFilterChange={setActiveFilter}
              totalProjects={caseStudies.length}
            />
            <CaseStudyGrid
              projects={filteredProjects}
              onSelectProject={handleSelectProject}
            />
            <PortfolioInquiry formUrl="https://readdy.ai/api/form/d6cl6bitehdqnvnpifhg" />
          </>
        )}
      </div>
    </Layout>
  );
}
